$(document).ready(() => {

    let paged = 1;
    let totalPages = Math.round($('.block-moderators').data('totalpages'));

    $('.js-filter-team').click(function(e){
        e.preventDefault();
        $(this).addClass('active').siblings('.js-filter-team').removeClass('active');
        paged = 1;
        filterTeam($(this), 'filter');
    });

    if ( paged >= totalPages ) {
        $('.js-load-team').hide();
    }

    $('.section-course-moderators .btn-clear-filter').click(function(e){
        e.preventDefault();
        paged = 1;
        let $form = $(this).parents('form');
        $form.find('.box-filter').removeClass('active');
        $form.find('.box-filter[data-type="all"]').addClass('active');
        $form[0].reset();
        filterTeam($(this), 'filter');
    });

    $('.form-search-team').submit(function(e){
        e.preventDefault();
        paged = 1;
        filterTeam($(this), 'filter');
    });

    $(document).on('click', '.js-load-team', function(e){
        e.preventDefault();
        paged += 1;
        filterTeam($(this), 'load');
    });

    function filterTeam($el, $event){
        let $parent = $el.parents('.section-course-moderators');
        let teamWrapp = $parent.find('.block-moderators');
        let $numberposts = $parent.data('numberposts');
        let $search = $parent.find('[name="search"]').val();
        let $search_2 = $parent.find('.box-filter.active').data('type');

        $('.loader').show();
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'filter_team',
                numberposts: $numberposts,
                search: $search,
                search_2: $search_2,
                paged: paged,
            },
            success(data) {
                let newTeam = $(data.content);
                totalPages = Math.round(newTeam.data('totalpages'));
                if ( paged >= totalPages  ) {
                    $parent.find('.js-load-team').hide();
                }
                else {
                    $parent.find('.js-load-team').show();
                }

                if ($event == 'load') {
                    teamWrapp.append(newTeam.find('.box-item'));
                }
                else {
                    teamWrapp.html(newTeam.find('.box-item'));
                }
            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

});
